// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__zyMKS","imageUploader":"EGiftCard_imageUploader__3Ev1A"};